type SuccessStateProps = {
	accentColor: string;
	wasMessageSubmission?: boolean;
};

export function SuccessState({
	accentColor,
	wasMessageSubmission,
}: SuccessStateProps) {
	return (
		<div
			className="text-center py-8 animate-fadeIn"
			style={{ "--checkmark-accent": accentColor } as any}
		>
			<div className="checkmark-container mb-6">
				<svg
					className="checkmark"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 52 52"
				>
					<title>Submission successful</title>
					<circle
						className="checkmark-circle"
						cx="26"
						cy="26"
						r="25"
						fill="none"
					/>
					<path
						className="checkmark-check"
						fill="none"
						d="M14.1 27.2l7.1 7.2 16.7-16.8"
					/>
				</svg>
			</div>
			<h2 className="text-xl mb-4 font-medium">Thank you!</h2>
			<p className="text-base leading-relaxed px-4 opacity-80">
				{wasMessageSubmission
					? "Your message has been received. We'll get back to you shortly."
					: "You will be called back shortly, make sure you are near your phone :)"}
			</p>
		</div>
	);
}
